import React from 'react'
import classNames from 'classnames'

import Switch from '../Switch'

import styles from './styles.module.scss'

type Props = {
  description?: string
  disabled?: boolean
  label: string
  onChange: (val: boolean) => void
  value: boolean
  /** marks a setting added by the SlothfulChat fork with a small badge */
  forkAdded?: boolean
}

export default function SettingsSwitch({
  description,
  disabled = false,
  label,
  onChange,
  value,
  forkAdded,
}: Props) {
  return (
    <label
      className={classNames(styles.settingsRow, {
        [styles.disabled]: disabled,
      })}
    >
      <div className={styles.settingsRowLeft}>
        <span
          className={classNames(styles.settingsRowLabel, {
            [styles.disabled]: disabled,
          })}
        >
          {label}
          {forkAdded && (
            <span
              className={styles.forkBadge}
              role='img'
              aria-label='SlothfulChat feature'
              title='Added by SlothfulChat — not part of upstream Delta Chat'
            >
              🦥
            </span>
          )}
        </span>
        {description && (
          <div
            className={classNames(styles.settingsRowDescription, {
              [styles.disabled]: disabled,
            })}
          >
            {description}
          </div>
        )}
      </div>
      <div className={styles.settingsRowRight}>
        <Switch checked={value} disabled={disabled} onChange={onChange} />
      </div>
    </label>
  )
}
